import { SchemeAttributeList } from './DynamicSchemeList'

export const getIsDynamicInputField = (schemeName: string, attributeName: string) => {
  if (!schemeName || !attributeName) return false

  const attributes = SchemeAttributeList.find(x =>
    x.names.some(name => name.toLocaleLowerCase() === schemeName.toLocaleLowerCase())
  )?.attributes

  if (!attributes) return false

  const isDynamicInput = attributes.some(
    y => y.attributeName?.toLocaleLowerCase() === attributeName.toLocaleLowerCase()
  )

  return isDynamicInput ?? false
}
